export default {
    Success: 'success',
    Warning: 'warning',
    Info: 'info',
    Error: 'error'
};
